import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import config from '../Common_Files/Config';
import { useEffect, useState } from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { Link } from "react-router-dom";
// import config from '../Common_Files/Config';
const ViewProduct = ({ product_id }) => {
  const resolvedProductId =
    product_id !== undefined && product_id !== null && product_id !== ''
      ? product_id
      : null;
  const [showGrnModal, setShowGrnModal] = useState(false);
  const [showCompleteOrderModal, setShowCompleteOrderModal] = useState(false);
  const [grnData, setGrnData] = useState([]);
  const [completeOrderData, setCompleteOrderData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState(null);

  const handleVatValidation = (e) => {
    const value = e.target.value;
    // Allow only alphanumeric characters, no spaces or special characters
    const alphanumericOnly = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 14);
    if (value !== alphanumericOnly) {
      e.target.value = alphanumericOnly;
    }
  };

  const fetchGrnData = async () => {
    if (resolvedProductId === null) {
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('product_id', resolvedProductId);
      const response = await fetch(`${config.api_url}/ws-product-wise-grn`, {
        method: "POST",
        body: formData
      });
      const data = await response.json();
      setGrnData(data?.data || []);
    } catch (err) {
      console.error('Error fetching GRN data:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCompleteOrder = async () => {
    if (resolvedProductId === null) {
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('product_id', resolvedProductId);
      const response = await fetch(`${config.api_url}/ws-product-wise-complete-order`, {
        method: "POST",
        body: formData
      });
      const data = await response.json();
      setCompleteOrderData(data?.data || []);
    } catch (err) {
      console.error('Error fetching GRN data:', err);
    } finally {
      setLoading(false);
    }
  };
  const [twelveMonthTurnoverData, setTwelveMonthTurnoverData] = useState([]);
  const fetchTwelveMonthTurnover = async () => {
    if (resolvedProductId === null) {
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('product_id', resolvedProductId);
      const response = await fetch(`${config.api_url}/ws-product-wise-twelve-month-turnover`, {
        method: "POST",
        body: formData
      });
      const data = await response.json();
      setTwelveMonthTurnoverData(data?.data || []);
    } catch (err) {
      console.error('Error fetching Twelve Month Turnover data:', err);
    } finally {
      setLoading(false);
    }

  }
  const handleGrnClick = () => {
    fetchGrnData();
    setShowGrnModal(true);
  };
  const handleCompleteOrder = () => {
    fetchCompleteOrder();
    setShowCompleteOrderModal(true);
  }
  useEffect(() => {
    if (resolvedProductId === null) {
      return;
    }
    fetchTwelveMonthTurnover();
  }, [resolvedProductId]);
  return (
    <div>
      <div className="modal fade" id="viewproduct" tabIndex="-1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">View Product Page</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="viewcustomer-area">
                <form id="viewProductForm">
                  <div className="row">
                    <div className="col-6 col-lg-6 col-sm-6">
                      <button className="popup-innerbtn-common">Credit Notes</button>
                      <button type="button" className="popup-innerbtn-common" onClick={handleCompleteOrder}>Completed Sales</button>
                      <button type="button" className="popup-innerbtn-common" onClick={handleGrnClick}>Completed PO</button>

                    </div>
                    <div className="col-6 col-lg-6 col-sm-6">
                      <div className="row">
                        <label htmlFor="inputText" className="col-sm-4" >&nbsp;</label>
                        <div className="col-sm-8">
                          <h4 id="product_status"></h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="devider" />
                  <div className="row">
                    <div className="col-6 col-lg-6 col-sm-6">
                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Code</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" id="code" disabled />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Brand</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" name="brand" id="brandname" disabled />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Pack</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" id="packValue" disabled />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">VAT</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" name="vat" id="vat" disabled onChange={handleVatValidation} />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Gross Weight</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" id="weight" disabled />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Net Weight</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" name="supplier" id="editnetWeight" disabled />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">CBM</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" name="cbm" id="viewcbm" disabled />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Supplier</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" name="supplier" id="supplier" disabled />
                        </div>
                      </div>

                    </div>
                    <div className="col-6 col-lg-6 col-sm-6">
                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Description</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" id="description" disabled />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Category</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" id="categooryName" disabled />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Size</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" id="sizeValue" disabled />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Unit Barcode</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" id="barcode" disabled />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Case Barcode</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" id="view_case_barcode" disabled />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Cost Price</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" id="case_price" disabled />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Sell Price</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" id="view_sell_price" disabled />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label htmlFor="inputText" className="col-sm-4 col-form-label">Case Per Pallet</label>
                        <div className="col-sm-8">
                          <input type="text" className="form-control" id="pallet_qty" disabled />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="viewcustomer-tbl-area">
                  <h5>Stock</h5>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <th>Free</th>
                        <th>Stock</th>
                        <th>On S.O</th>
                        <th>Alloc</th>
                        <th>On PF</th>
                        <th>On PO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Qty</td>
                        <td id="freestock">
                        </td>
                        <td id="stock"></td>
                        <td id="on_so"></td>
                        <td id="allocation"></td>
                        <td id="onpf"></td>
                        <td id="onpo"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="viewcustomer-tbl-area">
                  <h5>Last 12 Month Turnover</h5>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        {twelveMonthTurnoverData && Object.keys(twelveMonthTurnoverData).map(month => (
                          <th key={month}>
                            {new Date(month + '-01').toLocaleString('default', { month: 'short' })}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>T/O</td>
                        {twelveMonthTurnoverData && Object.values(twelveMonthTurnoverData).map((val, idx) => (
                          <td key={idx}>{val}</td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal centered show={showGrnModal} onHide={() => setShowGrnModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title as="h5" className="text-light fw-bold">GRN Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <p>Loading GRN data...</p>
          ) : (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  {/* <th>GRN ID</th> */}
                  <th>Reference No</th>
                  <th>Total Cost</th>
                  <th>Grand Total</th>
                </tr>
              </thead>
              <tbody>
                {grnData.length > 0 ? (
                  grnData.map((item, index) => (
                    <tr key={item.grn_id}>
                      <td>{index + 1}</td>
                      {/* <td>{item.grn_id}</td> */}
                      <td>
                        <a
                          href={`/editNewPurchaseOrder/${item.purchase_id || item.grn_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.reference_no}
                        </a>
                      </td>

                      <td>{item.total_product_cost}</td>
                      <td>{item.grand_total}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">No GRN data found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Modal.Body>

      </Modal>
      <Modal centered show={showCompleteOrderModal} onHide={() => setShowCompleteOrderModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title as="h5" className="text-light fw-bold">Complete Order Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <p>Loading Complete Order data...</p>
          ) : (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  {/* <th>GRN ID</th> */}
                  <th>Reference No</th>
                  <th>Gross Profit</th>
                  <th>Deliver Date & Time</th>
                </tr>
              </thead>
              <tbody>
                {completeOrderData.length > 0 ? (
                  completeOrderData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      {/* <td>{item.grn_id}</td> */}
                      <td>
                        <a
                          href={`/NewSalesOrderEdit/${item.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.reference_no}
                        </a>
                      </td>

                      <td>{item.gross_profit}</td>
                      <td>{item.delivery_date}{item.delivery_time}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">No data found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Modal.Body>

      </Modal>
    </div>
  );
};

export default ViewProduct;
